import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';
import { OnboardingStatus } from '@/enums/onboarding-status';

// ?preferred_variant=STARTER_PAGE_EXP:control
// ?preferred_variant=STARTER_PAGE_EXP:variant_1
// ?preferred_variant=STARTER_PAGE_EXP:variant_2
// ?preferred_variant=STARTER_PAGE_EXP:variant_3
// ?preferred_variant=STARTER_PAGE_EXP:variant_4
// ?preferred_variant=STARTER_PAGE_EXP:variant_5
// ?preferred_variant=STARTER_PAGE_EXP:variant_6

// ?remove_preferred_experiment=STARTER_PAGE_EXP

export const StarterPageExpName = 'STARTER_PAGE_EXP' as const;

export type StarterPageExpVariants = ToVariants<typeof StarterPageExpVariants>;

export const StarterPageExpVariants = {
	CONTROL: 'control',
	VARIANT_1: 'variant_1',
	VARIANT_2: 'variant_2',
	VARIANT_3: 'variant_3',
	VARIANT_4: 'variant_4',
	VARIANT_5: 'variant_5',
	VARIANT_6: 'variant_6',
} as const;

export default generate(
	StarterPageExpName,
	StarterPageExpVariants,
	() => {
		return true;
	},
	async instance => {
		return (
			!instance.$store.getters['user/isLoggedIn'] &&
			instance.$store.state.user['onboardingStatus'] === OnboardingStatus.GLOBAL
		);
	}
);
